export enum CRM_TYPES {
  SALESFORCE = 'salesforce',
  HUBSPOT = 'hubspot',
}

export enum SalesforceObjectTypes {
  CONTACT = 'Contact',
  ACCOUNT = 'Account',
  OPPORTUNITY = 'Opportunity',
}

export enum HubspotObjectTypes {
  CONTACT = 'Contact',
  COMPANY = 'Company',
  DEAL = 'Deal',
}

export type SalesforceApiAccount = {
  Id: string;
  Name: string;
  attributes: {
    type: SalesforceObjectTypes.ACCOUNT;
    url: string;
  };
  Website: string;
};

export type SalesforceApiContact = {
  Id: string;
  Name: string;
  Email: string;
  AccountId: string;
  attributes: {
    type: SalesforceObjectTypes.CONTACT;
    url: string;
  };
};

export type SalesforceApiOpportunity = {
  Id: string;
  Name: string;
  AccountId: string;
  StageName: string;
  Owner: {
    Email: string;
  };
  attributes: {
    type: SalesforceObjectTypes.OPPORTUNITY;
    url: string;
  };
};

export type SalesforceAccount = {
  id: string;
  name: string;
  type: SalesforceObjectTypes.ACCOUNT;
  website: string;
  crm: CRM_TYPES.SALESFORCE;
};

export type SalesforceContact = {
  id: string;
  name: string;
  email: string;
  accountId: string;
  type: SalesforceObjectTypes.CONTACT;
  crm: CRM_TYPES.SALESFORCE;
};

export type SalesforceOpportunity = {
  id: string;
  name: string;
  accountId: string;
  email: string;
  type: SalesforceObjectTypes.OPPORTUNITY;
  crm: CRM_TYPES.SALESFORCE;
};

export type SalesforceObject =
  | SalesforceAccount
  | SalesforceContact
  | SalesforceOpportunity;

export type SalesforceObjectsData = SalesforceObject[];

export interface HubSpotApiContact {
  id: string;
  properties: {
    email?: string;
    firstname?: string;
    lastname?: string;
    phone?: string;
    company?: string;
    createdate?: string;
    lastmodifieddate?: string;
    [key: string]: any;
  };
  createdAt: string;
  updatedAt: string;
}

export interface HubSpotApiCompany {
  id: string;
  properties: {
    name?: string;
    domain?: string;
    industry?: string;
    city?: string;
    state?: string;
    country?: string;
    phone?: string;
    createdate?: string;
    hs_lastmodifieddate?: string;
    [key: string]: any;
  };
  createdAt: string;
  updatedAt: string;
}

export interface HubSpotApiDeal {
  id: string;
  properties: {
    dealname?: string;
    amount?: string;
    dealstage?: string;
    pipeline?: string;
    closedate?: string;
    createdate?: string;
    hs_lastmodifieddate?: string;
    hubspot_owner_id?: string;
    [key: string]: any;
  };
  createdAt: string;
  updatedAt: string;
}

export type HubspotContact = {
  id: string;
  type: HubspotObjectTypes.CONTACT;
  name: string;
  email: string;
  crm: CRM_TYPES.HUBSPOT;
};

export type HubspotCompany = {
  id: string;
  name: string;
  domain: string;
  type: HubspotObjectTypes.COMPANY;
  crm: CRM_TYPES.HUBSPOT;
};

export type HubspotDeal = {
  id: string;
  name: string;
  type: HubspotObjectTypes.DEAL;
  crm: CRM_TYPES.HUBSPOT;
};

export type HubspotObject = HubspotContact | HubspotCompany | HubspotDeal;

export type HubspotObjectsData = HubspotObject[];

export type CRMObject = SalesforceObject | HubspotObject;

export enum SalesforceObjectsReferenceId {
  ACCOUNTS = 'accountsRef',
  CONTACTS = 'contactsRef',
  OPPORTUNITIES = 'opportunitiesRef',
}

export type SalesforceCompositeResponseItem<T> = {
  referenceId: SalesforceObjectsReferenceId;
  httpStatusCode: number;
  httpHeaders: Record<string, string>;
  body: {
    totalSize: number;
    done: boolean;
    records: T[];
  };
};

export type SalesforceObjectsCompositeResponse = {
  compositeResponse: [
    SalesforceCompositeResponseItem<SalesforceApiAccount>,
    SalesforceCompositeResponseItem<SalesforceApiContact>,
    SalesforceCompositeResponseItem<SalesforceApiOpportunity>
  ];
};

export const REFRESH_TOKEN_EXPIRATION_MESSAGE =
  'Salesforce authorization expired. Please reconnect your Salesforce account.';
